import React from 'react';
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';

export default function ExternalMemberForm({
  value,
  onChange,
  onSubmit,
  onCancel,
  saving,
  editing
}) {
  const update = (field, val) => onChange({ ...value, [field]: val });

  return (
    <Form onSubmit={onSubmit} className="recv-form-modern">
      <Row className="g-2">
        <Col md={3} xs={12}>
          <Form.Label>Nom</Form.Label>
          <Form.Control
            value={value.nom}
            onChange={(e) => update('nom', e.target.value)}
            required
          />
        </Col>
        <Col md={3} xs={12}>
          <Form.Label>Prénom (optionnel)</Form.Label>
          <Form.Control
            value={value.prenom}
            onChange={(e) => update('prenom', e.target.value)}
          />
        </Col>
        <Col md={2} xs={12}>
          <Form.Label>Sexe (optionnel)</Form.Label>
          <Form.Select value={value.sexe} onChange={(e) => update('sexe', e.target.value)}>
            <option value="">—</option>
            <option value="M">M</option>
            <option value="F">F</option>
          </Form.Select>
        </Col>
        <Col md={4} xs={12}>
          <Form.Label>Date naissance (optionnel)</Form.Label>
          <Form.Control
            type="date"
            value={value.date_naissance}
            onChange={(e) => update('date_naissance', e.target.value)}
          />
        </Col>
        <Col md={4} xs={12}>
          <Form.Label>Téléphone (optionnel)</Form.Label>
          <Form.Control
            value={value.telephone}
            onChange={(e) => update('telephone', e.target.value)}
          />
        </Col>
        <Col md={4} xs={12}>
          <Form.Label>Email (optionnel)</Form.Label>
          <Form.Control
            type="email"
            value={value.email}
            onChange={(e) => update('email', e.target.value)}
          />
        </Col>
        <Col md={4} xs={12}>
          <Form.Label>Adresse (optionnel)</Form.Label>
          <Form.Control
            value={value.adresse}
            onChange={(e) => update('adresse', e.target.value)}
          />
        </Col>
      </Row>
      <div className="d-flex gap-2 mt-3">
        <Button type="submit" disabled={saving}>
          {saving ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Enregistrement...
            </>
          ) : editing ? (
            'Mettre à jour'
          ) : (
            'Créer membre externe'
          )}
        </Button>
        {editing && (
          <Button variant="outline-secondary" onClick={onCancel} disabled={saving}>
            Annuler
          </Button>
        )}
      </div>
    </Form>
  );
}

